import {
  ApplicationConfig,
  isDevMode,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { providePrimeNG } from "primeng/config";
import { ConfirmationService, MessageService } from "primeng/api";
import { provideHttpClient } from "@angular/common/http";
import { provideTransloco } from "@jsverse/transloco";
import { TranslocoHttpLoader } from "./transloco-loader";
import { CodaCleanTheme } from "./mytheme";
import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import localeNl from "@angular/common/locales/nl";
import localeEn from "@angular/common/locales/en";

// Register locale data so the DatePipe can render month names (MMMM) in each supported language.
registerLocaleData(localeFr);
registerLocaleData(localeNl);
registerLocaleData(localeEn);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(),
    provideTransloco({
      config: {
        availableLangs: ["en", "nl", "fr"],
        defaultLang: "fr",
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: CodaCleanTheme,
        options: {
          darkModeSelector: false,
          cssLayer: false,
        },
      },
    }),
    MessageService,
    ConfirmationService,
  ],
};
